export enum ResultType {
	ResultPerRecord,
	JoinRecordsIntoASingleResult,
	ResultPerArrayItem,
	ReplaceInPlace,
}
